import { Capacitor } from '@capacitor/core';
import { TranslateService } from '@ngx-translate/core';
import { NiimbotPrinterService } from '@nebalkon-workspace/niimbot-printer';
import { NotSystemNotificationService } from '@nebalkon-workspace/ui-kit';

export interface PrintStaffEmployeeNameBadgeOptions {
  position?: string;
  name: string;
  printer: NiimbotPrinterService;
  translate: TranslateService;
  notification: NotSystemNotificationService;
}

export async function printStaffEmployeeNameBadge(
  options: PrintStaffEmployeeNameBadgeOptions,
): Promise<void> {
  const name = options.name.trim();
  if (!name) {
    options.notification.addToQueue({
      id: Date.now().toString(),
      type: 'error',
      text: [
        options.translate.instant('admin.employees.printNameBadgeNoName'),
      ],
    });
    return;
  }

  if (!options.printer.mayUseNiimbotPrinter()) {
    options.notification.addToQueue({
      id: Date.now().toString(),
      type: 'error',
      text: [options.translate.instant('printer.staffAccessDenied')],
    });
    return;
  }

  if (!Capacitor.isNativePlatform()) {
    options.notification.addToQueue({
      id: Date.now().toString(),
      type: 'error',
      text: [options.translate.instant('printer.bleUnavailable')],
    });
    return;
  }

  if (!options.printer.isConnected()) {
    options.notification.addToQueue({
      id: Date.now().toString(),
      type: 'error',
      text: [options.translate.instant('printer.notConnected')],
    });
    return;
  }

  try {
    await options.printer.printNameBadge(
      {
        position: options.position?.trim() || undefined,
        name,
      },
      1,
    );
    options.notification.addToQueue({
      id: Date.now().toString(),
      type: 'success',
      text: [
        options.translate.instant('admin.employees.printNameBadgeSuccess'),
      ],
    });
  } catch {
    options.notification.addToQueue({
      id: Date.now().toString(),
      type: 'error',
      text: [options.translate.instant('admin.employees.printNameBadgeError')],
    });
  }
}
